import ApiService from "@/modules/api/api.service";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import { Dictionary } from "@/lib/Dictionary.type";

import Upgrade from "./upgrade.model";
import ExtraChargeOption from "./extra-charge-option.model";
import ExtraChargeOptionFactory from "./extra-charge-option.factory";

export default class UpgradeRepository extends BasicRepository<Upgrade> {
  private fExtraChargeOptionFactory = new ExtraChargeOptionFactory();

  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<Upgrade>,
    responseParser: ApiCollectionResponseParserService<Upgrade>
  ) {
    super("plushie_upgrades", api, objectBuilder, responseParser);
  }

  public async getExtraChargeOptions(
    plushieId: string
  ): Promise<ExtraChargeOption[]> {
    const response = await this.api.get(
      `plushies/${plushieId}/extra_charge_options`,
      undefined,
      undefined,
      undefined,
      false
    );

    const items: ExtraChargeOption[] = [];

    if (Array.isArray(response.data.items)) {
      response.data.items.forEach((item: { [key: string]: any }) => {
        items.push(this.fExtraChargeOptionFactory.buildFromJSON(item));
      });
    }

    return items;
  }

  public async requestPaymentLink({
    plushieId,
    items,
  }: {
    plushieId: string;
    items: Array<{ upgradeCode: string; quantity: number }>;
  }): Promise<string> {
    const response = await this.api.post(
      "plushie_extra_charge_payment_link_requests",
      {
        plushieId,
        items,
      }
    );

    return response.data.url as string;
  }

  protected prepareData(item: Upgrade): Dictionary<string | number | boolean> {
    const data: Dictionary<string | number | boolean> = {
      id: item.id,
      code: item.code,
      displayToFactory: item.displayToFactory,
      title: item.name,
      isManageable: item.isManageable,
      isManualAssignmentAllowed: item.isManualAssignmentAllowed,
    };

    if (item.shortName) {
      data.shortName = item.shortName;
    }

    return data;
  }
}
